export default __webpack_public_path__ + "static/media/MariaDB-WindowsTaskScheduler-Action-StartaProgram06.9597cea7.png";